// extracted by mini-css-extract-plugin
module.exports =  {"visuallyHidden":"visuallyHidden_CQrPbGhe"};